import React from 'react';
import DynamicForm from './DynamicForm';

const Homework9 = () => {
  return (
    <div>
      <h1>Форма регистрации</h1>
      <DynamicForm />
    </div>
  );
};

export default Homework9;
